import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiModule, BASE_PATH } from '../apiModule/index';

import { DialogsService } from './index';

import { AppSettings, AppSettingsService, AuthorizationGuard, AuthorizationService, LoaderService } from './index';

import { AuthHttpInterceptor, SECURITY_CONFIG, SecurityServiceConfig, XpoSecurityModule } from '@xpo/security';

import { ConfirmDialog } from './index';

import { MessengerInterceptor } from './index';

import 'rxjs/add/operator/do';

// to store the settings once it has loaded
let globalAppSettings: AppSettings;

export function init_app(service: AppSettingsService) {
  return () => service.getSettings().do((c) => { globalAppSettings = c; }).toPromise();
}

export function init_security_config(settings: AppSettings) {
  return new SecurityServiceConfig({
    appCode: settings.appCode,
    authorityUri: settings.authorityUri,
    applicationRootUri: window.location.origin,
    enableLogging: settings.enableAuthLogging,
    scopes: settings.scopes,
    authApiBasePath: settings.apiUri,
  });
}

@NgModule({
  exports: [ConfirmDialog],
  declarations: [ConfirmDialog],
  imports: [
    ApiModule,
    BrowserAnimationsModule,
    XpoSecurityModule,
  ],
  providers: [
    AppSettingsService,
    { provide: APP_INITIALIZER, useFactory: init_app, deps: [AppSettingsService], multi: true },
    { provide: AppSettings, useFactory: () => globalAppSettings, deps: [APP_INITIALIZER] },
    { provide: BASE_PATH, useFactory: (settings: AppSettings) => settings!.apiUri, deps: [AppSettings] },
    { provide: SECURITY_CONFIG, useFactory: init_security_config, deps: [AppSettings] },
    { provide: HTTP_INTERCEPTORS, useClass: MessengerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    AuthorizationService,
    AuthorizationGuard,
    LoaderService,
    DialogsService,
  ],
  entryComponents: [ConfirmDialog],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreModule { }



// WEBPACK FOOTER //
// /ng-app/src/core/core.module.ts